import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useMutationPay } from '@workspace/core-ts/api';
import { useGlobalForm, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { useEffect, useRef, useState } from 'react';

interface ValidationPaiementAvenantProps {
    /** Transformation du payload /pay (ex. format legacy de l'app avenant). Identité par défaut. */
    payloadTransform?: (data: any) => any;
}

export function ValidationPaiementAvenant({ payloadTransform = (data) => data }: ValidationPaiementAvenantProps = {}) {
    const methods = useSmartFormGlobal<any>();
    const { meta } = useGlobalForm();
    const [error, setError] = useState<string | null>(null);

    const mutationPay = useMutationPay(meta.token);
    const payDemande = useRef(false);

    useEffect(() => {
        // why: un seul appel /pay (StrictMode rejoue les effets en dev)
        if (payDemande.current) return;
        payDemande.current = true;

        const validateAvenant = async () => {
            try {
                const data = methods.getValues();

                const payResponse = await mutationPay.mutateAsync({
                    ...payloadTransform(data),
                    url_return: window.location.origin.toString(),
                    redirection: false,
                });

                if (payResponse) {
                    window.location.href = payResponse;
                }
            } catch (err) {
                console.error('Erreur validation avenant:', err);
                setError(err instanceof Error ? err.message : 'Une erreur est survenue');
            }
        };

        validateAvenant();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isLoading = mutationPay.isPending;

    if (error && !isLoading) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[400px] space-y-6 px-4">
                <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
                    <span className="text-3xl">⚠️</span>
                </div>
                <div className="text-center space-y-2">
                    <h2 className="text-xl font-semibold text-gray-900">Erreur lors de la validation</h2>
                    <p className="text-gray-600 max-w-md">{error}</p>
                </div>
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    className="px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                    Réessayer
                </button>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-[400px] space-y-6">
            <div className="relative">
                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary"></div>
                <CheckCircleIcon className="w-8 h-8 text-primary absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
            </div>
            <div className="text-center space-y-2">
                <h2 className="text-xl font-semibold text-gray-900">Validation de votre avenant</h2>
                <p className="text-gray-600">Veuillez patienter pendant que nous finalisons votre demande...</p>
            </div>
        </div>
    );
}
